import { render, staticRenderFns } from "./testItem-add-or-update.vue?vue&type=template&id=7fc573aa&scoped=true"
import script from "./testItem-add-or-update.vue?vue&type=script&lang=js"
export * from "./testItem-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc573aa",
  null
  
)

export default component.exports